import { inject, provide, type App } from 'vue'

export type PricingModeOpt = Partial<{
  /**
   * @default 9
   */
  oneway: number

  /**
   * @default 10
   */
  roundtrip: number

  /**
   * @default true
   */
  show: boolean
}>


const getWithDefaultPricing = (opt: PricingModeOpt = {}) => {
  const { oneway = 9, roundtrip = 10, show = true } = opt

  return { oneway, roundtrip, show }
}

const KEY = Symbol('usePricingMode')

export const usePricingMode = (opt: PricingModeOpt = {}) => {
  const pricing = getWithDefaultPricing(opt)

  return inject(KEY, pricing)
}

usePricingMode.provide = (opt: PricingModeOpt, app?: App) => {
  const pricing = getWithDefaultPricing(opt)

  app ? app.provide(KEY, pricing) : provide(KEY, pricing)
}